import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { ImportantNotice } from './ImportantNotice';
import { IntroContent } from './IntroContent';
import { KeyHighlights } from './KeyHighlights';
import { WhatYoullLearn } from './WhatYoullLearn';
import { CalendarCallout } from './CalendarCallout';
import { ContactSection } from './ContactSection';
import { QuickLinks } from './QuickLinks';
export function RefuseVictimPage() {
  return <PageLayout data-id="element-3135">
      <HeaderBanner data-id="element-3136" />
      <ImportantNotice data-id="element-3137" />
      <IntroContent data-id="element-3138" />
      <KeyHighlights data-id="element-3139" />
      <WhatYoullLearn data-id="element-3140" />
      <CalendarCallout data-id="element-3141" />
      <ContactSection data-id="element-3142" />
      <QuickLinks data-id="element-3143" />
    </PageLayout>;
}